import React, { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

const pricingPlans = [
  {
    title: 'Hourly Plan',
    price: '$15 - $20/hr',
    features: [
      'Flexible Hours',
      'Priority Support',
      'Pay As You Go',
      'Access to All Features',
    ],
  },
  {
    title: 'Monthly Plan',
    price: '$3k - $35k/mo',
    features: [
      'Full-time Commitment',
      '24/7 Support',
      'Dedicated Account Manager',
      'Advanced Analytics',
    ],
  },
]

const Pricing = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true })
  }, [])

  return (
    <section className="py-24 px-6 sm:px-12 lg:px-20" id="pricing">
      <h2 className="text-lg leading-7">Our Pricing</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
        Choose Your Plan
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-10">
        {pricingPlans.map((plan, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 200}
            className="relative ring-2 ring-base-300 bg-base-200 rounded-2xl shadow-xl p-6"
          >
            <h3 className="text-2xl font-bold text-base-content">
              {plan.title}
            </h3>
            <p className="mt-2 text-3xl font-bold text-base-content">
              {plan.price}
            </p>
            <ul className="mt-4 text-sm list-disc pl-5 space-y-2">
              {plan.features.map((feature, i) => (
                <li key={i} className="text-gray-400">
                  {feature}
                </li>
              ))}
            </ul>
            <button className="mt-6 w-full py-2 btn btn-outline text-sm">
              Get Started
            </button>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Pricing
